import { Component } from "react";
import { connect } from "react-redux";
import { refuse } from "../../redux/absences/absencesEditionActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import CustomizedTextField from "../Input/CustomizedTextField";
import Icon from "@mui/material/Icon/Icon";
import Button from "@mui/material/Button/Button";
import Fab from "@mui/material/Fab";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import { FormControl, InputLabel } from "@mui/material";
import CustomizedSelect from "../Input/CustomizedSelect";

class RefuseAbsenceModal extends Component {
    constructor(props) {
        super(props);

        let selectedReasonId = 0;
        if (props.absences.refuseReasons.length > 0) {
            selectedReasonId = props.absences.refuseReasons[0].id;
        }

        this.state = {
            open: false,
            selectedReasonId,
            comment: "",
        };
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    refuse() {
        this.props.refuse(this.props.absences, this.props.activeUser, this.state.selectedReasonId, this.state.comment);
    }

    onReasonChange(e) {
        this.setState({
            selectedReasonId: e.target.value,
        });
    }

    onCommentChange(e) {
        this.setState({
            comment: e.target.value,
        });
    }

    render() {
        let rowsReasons = [];
        for (let i = 0; i < this.props.absences.refuseReasons.length; i++) {
            let currentReason = this.props.absences.refuseReasons[i];

            rowsReasons.push(
                <MenuItem key={i} value={currentReason.id}>
                    {currentReason.name}
                </MenuItem>
            );
        }

        return (
            <div>
                <Fab onClick={this.handleClickOpen.bind(this)} color="primary" className="div-center red-button">
                    <Icon>block</Icon>
                </Fab>
                <span className="floating-btn-text span-center">Refuser</span>
                <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Motif de refus</DialogTitle>
                    <DialogContent>
                        <FormControl className="row">
                            <InputLabel id="reason-label">Motif</InputLabel>
                            <CustomizedSelect
                                label="Motif"
                                labelId="reason-label"
                                id="reason"
                                inputProps={{ name: "reason", id: "reason" }}
                                value={this.state.selectedReasonId}
                                onChange={this.onReasonChange.bind(this)}
                                placeholder="Motif"
                                className="full_size"
                            >
                                {rowsReasons}
                            </CustomizedSelect>
                        </FormControl>
                        <CustomizedTextField
                            value={this.state.comment}
                            multiline
                            autoFocus
                            onChange={this.onCommentChange.bind(this)}
                            margin="dense"
                            id="comment"
                            label={"Commentaire"}
                            fullWidth
                            className="full_size"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.refuse.bind(this)} className="button" color="primary">
                            Refuser
                        </Button>
                        <Button className="button red-button" onClick={this.handleClose} color="primary">
                            Annuler
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        refuse: (absencesState, activeUser, reasonId, comment) =>
            dispatch(refuse(absencesState, activeUser, reasonId, comment)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(RefuseAbsenceModal);
